<template>
  <div>
    <div class="structured-top">
      <h1 v-mark-word>{{ $t('myNotifications.title') }}</h1>
      <span class="lead">{{ $t('myNotifications.hint') }}</span>
    </div>
    <div class="structured-content">
      <div v-if="!notifications.length" class="alert mb-7" role="alert">{{ $t('myNotifications.emptyList') }}</div>
      <table v-else class="table structure-table structure-table-borders">
        <thead>
          <tr>
            <th class="d-none d-xl-table-cell col-1">{{ $t('myNotifications.table.columnDate') }}</th>
            <th class="d-none d-xl-table-cell">{{ $t('myNotifications.table.columnTitle') }}</th>
            <th class="d-none d-xl-table-cell" />
          </tr>
        </thead>
        <tbody>
          <template v-for="notification in notifications">
            <tr>
              <td class="align-baseline">
                {{ $date(notification.notificationAddedDate) }}
                <a
                  class="btn btn-sm btn-default float-end position-absolute mt-2 me-3 mb-2 d-xl-none notification-button"
                  @click="toggleExpanded(notification)"
                >
                  {{ isExpanded(notification)
                    ? $t('myNotifications.table.buttonCloseBody')
                    : $t('myNotifications.table.buttonOpenBody') }}
                </a>
              </td>
              <td class="align-baseline d-none d-xl-table-cell">
                <span v-bind:class="{ 'fw-bold': !notification.isNotificationSeen }">
                  {{ notification.notificationTitle }}
                </span>
                <br>
                <div v-if="isExpanded(notification)" class="mt-2">
                  <span v-html="notification.notificationBody" />
                </div>
              </td>
              <td class="align-baseline d-xl-none mobile-border mt-2">
                <span v-bind:class="{ 'fw-bold': !notification.isNotificationSeen }">
                  {{ notification.notificationTitle }}
                </span>
                <div v-if="isExpanded(notification)" class="mt-2">
                  <span v-html="notification.notificationBody" />
                </div>
              </td>
              <td class="btn-col d-none d-xl-table-cell">
                <a
                  class="btn btn-default float-end position-absolute notification-button"
                  @click="toggleExpanded(notification)"
                >
                  {{ isExpanded(notification)
                    ? $t('myNotifications.table.buttonCloseBody')
                    : $t('myNotifications.table.buttonOpenBody') }}
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  components: {},
  data: () => ({
    notifications: [],
  }),
  computed: {
    ...mapState('session', ['profile']),
  },
  methods: {
    ...mapActions('notification', ['getMyNotifications', 'getMyNotificationBody']),
    ...mapMutations('session', ['redirectAfterLogin']),

    redirectIfNotLoggedIn() {
      if (!this.profile.personId) {
        this.redirectAfterLogin(this.$route.fullPath);
        this.$router.push({ name: `login-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
      }
    },
    loadNotifications() {
      this.getMyNotifications()
        .then((response) => this.notifications = response)
        .then((response) => this.updateUnreadCount(response));
    },
    updateUnreadCount(response) {
      let unreadCount = 0;
      response.forEach((notification) => {
        if (!notification.isNotificationSeen) {
          unreadCount++;
        }
      });
      this.profile.unreadNotificationCount = unreadCount;
    },
    loadNotificationBody(notification) {
      if (!notification.isNotificationSeen) {
        this.profile.unreadNotificationCount--;
      }
      this.getMyNotificationBody(notification.notificationId)
        .then((response) => {
          notification.notificationBody = response.notificationBody;
        });
    },
    toggleExpanded(notification) {
      if (!notification.notificationBody) {
        this.loadNotificationBody(notification);
        if (!notification.isNotificationSeen) {
          notification.isNotificationSeen = true;
        }
      }
      notification.isExpanded = !notification.isExpanded;
    },
    isExpanded(notification) {
      if (notification.isExpanded === undefined) {
        notification.isExpanded = false; // always start notifications as collapsed and give value
      }
      return notification.isExpanded;
    },
  },
  created() {
    this.redirectIfNotLoggedIn();
    this.loadNotifications();
  },
  metaInfo() {
    return {
      title: this.$t('myNotifications.meta.title'),
      meta: [],
    };
  },
};
</script>
